import OrganizationTransfer from '@/screens/OrganizationTransfer';

export default function Route() {
  return <OrganizationTransfer />;
}
